import { render, staticRenderFns } from "./TransactionGateWayView.vue?vue&type=template&id=516b8da2&scoped=true&"
import script from "./TransactionGateWayView.vue?vue&type=script&lang=ts&"
export * from "./TransactionGateWayView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b8da2",
  null
  
)

export default component.exports